import { OuiSelectOption } from 'omnium-ui/form-field';

export const atlasInvestorStatusOptions: OuiSelectOption<string>[] = [
  { label: 'ANNULE', value: 'ANNULE' },
  { label: 'ARCHIVE', value: 'ARCHIVE' },
  { label: 'CLIENT', value: 'CLIENT' },
  { label: 'CONTACT', value: 'CONTACT' },
  { label: 'NR', value: 'NR' },
  { label: 'PROSPECT', value: 'PROSPECT' },
  { label: 'RELATION', value: 'RELATION' },
  { label: 'SUPPRIME', value: 'SUPPRIME' },
];

export const atlasInvestorStatusOptionsWithAll: OuiSelectOption<string | null>[] = [
  { label: 'Tous les statuts', value: null },
  ...atlasInvestorStatusOptions,
];
